// Curated agency logos for the home marquee.
//
// The two home scrollers previously derived their logos dynamically from the
// published ads (see the removed `uniqueAgencyLogos` path in Home.vue). They now
// show this fixed, hand-picked set of partner agencies instead. Each logo was
// downloaded from the agency's own Newarc profile
// (Firebase Storage: agencies/{agencyId}/agency-profile.*) and lives, optimised,
// in src/assets/img/loghi-agenzie/. Order here is the order in the marquee.

import chiusano from '@/assets/img/loghi-agenzie/chiusano.jpg';
import houseFactory from '@/assets/img/loghi-agenzie/house-factory.jpg';
import abytare from '@/assets/img/loghi-agenzie/abytare.png';
import casaMassa from '@/assets/img/loghi-agenzie/casa-massa.png';
import professioneCasaParella from '@/assets/img/loghi-agenzie/professionecasa-parella.png';
import gnm from '@/assets/img/loghi-agenzie/gnm-immobiliare.png';
import freedom from '@/assets/img/loghi-agenzie/freedom.jpg';
import gaia from '@/assets/img/loghi-agenzie/gaia-real-estate.png';

export const HOME_AGENCY_LOGOS = [
  { name: 'Chiusano', logo: chiusano },
  { name: 'House Factory', logo: houseFactory },
  { name: 'Gruppo Abytare', logo: abytare },
  { name: 'Casa Massa', logo: casaMassa },
  { name: 'ProfessioneCasa Parella', logo: professioneCasaParella },
  { name: 'GNM Immobiliare', logo: gnm },
  { name: 'Freedom', logo: freedom },
  { name: 'Gaia Real Estate', logo: gaia },
];
